module.exports = __webpack_public_path__ + "static/media/starterguide5v2.dc5e52d1.png";